import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
	chatFooter: {
		flexShrink: 0,
		padding: "10px 18px 14px",
		fontSize: "11.5px",
		fontFamily: "var(--font-sans)",
		fontWeight: 500,
		letterSpacing: "0.01em",
		lineHeight: 1.4,
		color: "var(--color-muted)",
		textAlign: "center",
		background: "var(--surface-bg)",
		"& p": {
			margin: 0,
		},
	},
});

export default function ChatFooter({ footer }) {
	const classes = useStyles();
	if (!footer) return null;
	return (
		<footer className={classes.chatFooter}>
			<p>{footer}</p>
		</footer>
	);
}
